import React from 'react';
import debounce from 'debounce';

import { AutoComplete } from 'antd';

import { _getSearchSupplier } from '../../services';

const Option = AutoComplete.Option;

class SupplierAutocomplete extends React.Component{

	render(){

		const { dataSource } = this.state;

		return (
			<AutoComplete

				style={{ width: 200 }}
				onSelect={this.onSelect}
				onChange={this.onChange}
				optionLabelProp="companyName"
				placeholder="Search Company Name"

			>

			{dataSource.map(
				supplier => (
					<Option 
						companyName={supplier.details.companyName} 
						key={`${supplier._id}~!@${supplier.details.companyName}~!@${supplier.local.email}`}>
						<div>{supplier.details.companyName}</div>
						<div>{supplier.local.email}</div>
					</Option>
				)
			)}

			</AutoComplete>

		)
	}

	state = {
		dataSource: []
	}

	constructor(props){
		super(props);

		this.handleSearch = debounce(this.handleSearch, 200);
	}

	onChange = ( searchTerm ) => {
		this.handleSearch( searchTerm );
	}

	onSelect = (e) => {
		this.props.onSelect(e)
	}

	handleSearch = ( value ) => {

		if( !value ){
			return this.setState({
				dataSource: []
			})
		}

		_getSearchSupplier( value )
			.then( res => {
				this.setState({
					dataSource: res.data.suppliers
				})
			})
		
	}

}

export default SupplierAutocomplete;


// WEBPACK FOOTER //
// ./src/components/supplier/autocomplete.js